import React, { forwardRef } from 'react';

import styles from './Input.module.scss';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'prefix' | 'postfix'> {
  postfix?: React.ReactNode;
  prefix?: React.ReactNode;
  variant?: 'default' | 'small';
  inputStyle?: 'table';
  label?: string;
};

const Input = forwardRef<HTMLInputElement, InputProps>(({
  prefix,
  postfix,
  className,
  variant = 'default',
  inputStyle,
  ...props
}, ref) => {
  return (
    <div className={`${styles.fieldContainer} ${className || ""}`}>
      <div className={`${styles.inputWrapper} ${variant === 'small' && styles.small} ${inputStyle === 'table' && styles.tableDataInput}`}>
        {prefix}
        <input
          ref={ref}
          {...props}
          step={props.type === 'number' ? props.step : undefined}
        />
        {postfix}
      </div>
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
